export const IntercomAPI = (eventType, eventName) => {
    return window.Intercom(eventType, eventName);
  }; 